import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

export default function AdminProtectedRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);
  // `me` may not have loaded yet on a hard refresh (token present, user undefined).
  // Hold the render rather than bouncing a real admin to /pipeline.
  if (token && user === null) return null;
  if (user?.role !== "admin") return <Navigate to="/pipeline" replace />;
  return <>{children}</>;
}
